import React from "react";
import Pool from "../../UserPool";
import QAEvalCaseQuery from "../VAEval/QAEvalCaseQuery";

export default function QAEvalLanding({ setAuth, setUserOrg }) {
  const logoutUser = () => {
    const user = Pool.getCurrentUser();
    if (user) {
      user.signOut();
    }

    localStorage.removeItem("token");
    setUserOrg(null);
    setAuth(false);
  };

  return (
    <div className="min-h-screen bg-gray-50 text-ktx-purple px-2 md:px-3 lg:px-4 py-5">
      <button
        className="fixed top-4 right-4 flex hover:text-ktx-navy font-medium text-[24px] items-center gap-1"
        onClick={logoutUser}
        type="button"
      >
        <svg
          className="w-6 h-6"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M20 12H8m12 0-4 4m4-4-4-4M9 4H7a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h2"
          />
        </svg>
        Logout
      </button>

      <div className="w-full max-w-[96vw] mx-auto">
        <h1 className="text-[36px] font-semibold mb-4">QA Eval Workspace</h1>
        <QAEvalCaseQuery />
      </div>
    </div>
  );
}
